<div class="d-flex flex-column justify-content-around">
  <rask-button
    class="menu-btn"
    color="tertiary"
    icon="far fa-copy"
    (click)="copy()"
    ngbTooltip="{{x}} {{y}}">
    Kopiera koordinat till urklipp<small></small>
  </rask-button>

  @if (canPaste()) {
    <rask-button
      class="menu-btn"
      color="tertiary"
      icon="fa-solid fa-hand-point-right"
      (click)="navigate()">
      Navigera till koordinat från urklipp
    </rask-button>
  }

  @if (point) {
    <div>
      <rask-edit-menu [map]="map" [mapSettings]="mapsettings" [geometries]="geometries" [point]="point" [readonly]="true"></rask-edit-menu>
    </div>
  }
</div>